<template>
  <div class="router-transitions container-fluid flex-grow-1 map-home">
    <router-view></router-view>
    <div v-if="$route.name === 'map-home'" class="p-5 text-big">You need to create and publish at least one floor...</div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import store from '@/store'

const redirectToMap = (to, from, next) => {
  if (to.name === 'map-home') {
    const resolveRoute = () => {
      let floor = store.getters['floor/floors'].find((floor) => +floor.status)
      floor ? next({ name: 'map', params: { floorId: floor.id } }) : next()
    }

    if (store.state.floor.floorsLoaded) {
      resolveRoute()
    } else {
      store.watch((state) => state.floor.floorsLoaded, (loaded) => {
          // wait for initial loading
          if (loaded) {
            resolveRoute()
          }
        })
    }
  } else {
    next()
  }
}

export default {
  name: 'map-home',
  computed: {
    ...mapGetters('floor', ['floors'])
  },
  beforeRouteUpdate(to, from, next) {
    redirectToMap(to, from, next)
  },
  beforeRouteEnter(to, from, next) {
    redirectToMap(to, from, next)
  }
}
</script>

<style scoped>
.map-home {
  padding: 0 !important;
  background: #fff;
}

.empty-message {
}
</style>
